import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_n5qta5twp3: FaireBrandEntity = {
  token: "b_n5qta5twp3",
  type: "brand",
  name: "Rad Toddler Co.",
  avatarUrl:
    "https://cdn.faire.com/fastly/f87ff52e552bd5c11bd5756aca0bfbe3ece8886cf8d92eff14f377496c93c31b.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/ea0940cc552e7f5cc4c4ada156a05219897f7e002e53fb7b6bec2be7aef69539.png",
  logoUrl:
    "https://cdn.faire.com/fastly/f87ff52e552bd5c11bd5756aca0bfbe3ece8886cf8d92eff14f377496c93c31b.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/ea0940cc552e7f5cc4c4ada156a05219897f7e002e53fb7b6bec2be7aef69539.png",
  location: "Torrance , CA, USA",
  minimumOrderDollars: 416,
  rating: 4.7,
  reviewCount: 3,
  isInsider: true,
  description:
    "Rad Tod Co. was created in 2020 when we welcomed our first baby boy! We quickly realized that finding cool trendy clothes for boys was very difficult. Fall of 2021 our website went live and we became very popular with our bee-happy collection. The following year we started introducing clothes, board shorts, and pajamas. ",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:44.803Z",
    importedBy: "entity-db-cli",
  },
};
